var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph"},[(_vm.curriculum)?_c('curriculum',_vm._b({ref:"curriculum",attrs:{"curriculum":_vm.curriculum}},'curriculum',_vm.options,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }